import { pushModalTransition, popAllModalTransition } from '../actions/modalActions';
import { modalShepherdSingleton } from '../components/modalShepherdComponent';

// TODO Add a modal redux-saga channel and make this a saga!
export function launchModal(init, overrides, e, componentName) {
    const payload = pushModalTransition(
        init,
        overrides,
        e,
        componentName
    );

    $.event.trigger({
        type: payload.type,
        payload: payload
    });

    return payload;
}

// Convenience method for this often-repeated segment of code,
// used to close modals
export function closeModal(e, self) {
    const payload = popAllModalTransition(e, self.name);
    $.event.trigger({
        type: payload.type,
        payload: payload
    });
}

/**
 * Method to check if there is currently a modal open
 * on the site. Uses singleton exported from modal shepherd
 * component to check the stack length
 * @returns {boolean} is modal open?
 */
export function isModalOpen() {
    if (modalShepherdSingleton.stack.length > 0) {
        return true;
    }

    return false;
}
